module.exports = __webpack_public_path__ + "static/img/wrp875.6b34fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wrp875.jpg
// module id = 90Y+
// module chunks = 0